var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49817 1.95461C9.49013 0.959909 10.9589 0.610973 12.2922 1.05326V1.05326C12.5043 1.12359 12.6741 1.28781 12.7532 1.49672V1.49672C13.2958 2.92944 12.9549 4.56203 11.8731 5.64683L7.11106 10.4221L3.57768 6.88871L8.49817 1.95461Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95031 3.1054L3.44625 3.1054C3.31364 3.1054 3.18646 3.15808 3.0927 3.25185L0.955284 5.38926C0.672903 5.67164 0.819187 6.15478 1.21078 6.2331L4.71138 6.93322",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8948 6.0499V10.554C10.8948 10.6866 10.8421 10.8137 10.7483 10.9075L8.61092 13.0449C8.32854 13.3273 7.8454 13.181 7.76708 12.7894L7.06696 9.28883",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53343 8.69994L3.43938 8.75637C2.55495 9.28702 1.90968 10.1388 1.6383 11.1339L1.29296 12.4001C1.24206 12.5867 1.41331 12.758 1.59993 12.7071L2.86618 12.3618C3.86125 12.0904 4.71313 11.4449 5.24378 10.5605C5.26303 10.5284 5.28185 10.4971 5.30012 10.4666",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceman);
export default __webpack_public_path__ + "static/media/spaceman.0688ac42.svg";
export { ForwardRef as ReactComponent };